// Lazysizes
import 'lazysizes';

// Alpine bootup

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import { tns } from "tiny-slider/src/tiny-slider";
import masonry from 'alpinejs-masonry'


window.tns = tns


window.Alpine = Alpine;
Alpine.plugin(masonry)
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();


